import React, { useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';

import styles from './StartCaptureModal.module.css';
import { CAPTURE_PROTOCOLS_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { Dropdown } from '@silverfort/sf-components';

const StartCaptureModal = ({ onApprove, onCancel, dcCaptureConfig }) => {
    const [selectedDcCaptureConfig, setSelectedDcCaptureConfig] = useState(dcCaptureConfig);
    const handleCaptureTimeChange = (e) => {
        const newVal = e.target.value && !isNaN(e.target.value) ? parseInt(e.target.value) * 60 : 0;
        if (newVal > 0) {
            setSelectedDcCaptureConfig({ ...selectedDcCaptureConfig, maxTimeSec: newVal });
        }
    };

    const handleCaptureSizeChange = (e) => {
        const newVal = e.target.value && !isNaN(e.target.value) ? parseInt(e.target.value) : 0;
        if (newVal > 0) {
            setSelectedDcCaptureConfig({ ...selectedDcCaptureConfig, maxSizeMb: newVal });
        }
    };

    return (
        <Modal
            id={styles.StartCaptureModal}
            dialogClassName="modal-lg"
            show={true}
            onHide={onCancel}
            enforceFocus={false}
            className="z-[5000]"
            backdropClassName="z-[900]"
            keyboard={true}
            backdrop="static">
            <Modal.Header closeButton={false}>
                <Modal.Title>Traffic Capture</Modal.Title>
                <div className={styles.titleDescription}>Set the parameters to include in the PCAP traffic capture</div>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.captureField}>
                    <div className={styles.captureFieldLabel}>Protocols:</div>
                    <div className={styles.captureFieldData}>
                        <Dropdown
                            items={Object.values(CAPTURE_PROTOCOLS_OPTIONS).map((option) => ({
                                value: option.value,
                                title: option.label,
                                disabled: option.disabled
                            }))}
                            selectedItems={selectedDcCaptureConfig.protocols}
                            variant="trigger"
                            multiple={true}
                            onChange={(value) => {
                                setSelectedDcCaptureConfig({
                                    ...selectedDcCaptureConfig,
                                    protocols: value?.length ? value : []
                                });
                            }}
                        />
                    </div>
                </div>

                <div className={styles.captureField}>
                    <div className={styles.captureFieldLabel}>Time (minutes):</div>
                    <div className={styles.captureFieldData}>
                        <input
                            value={selectedDcCaptureConfig.maxTimeSec / 60}
                            onChange={handleCaptureTimeChange}
                            className={styles.inputField}
                            type="number"
                            min="1"
                        />
                    </div>
                </div>
                <div className={styles.captureField}>
                    <div className={styles.captureFieldLabel}>Maximum capture size (Mb):</div>
                    <div className={styles.captureFieldData}>
                        <input
                            value={selectedDcCaptureConfig.maxSizeMb}
                            onChange={handleCaptureSizeChange}
                            className={styles.inputField}
                            type="number"
                            min="1"
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onCancel}>Cancel</Button>
                <Button
                    bsStyle={'success'}
                    disabled={selectedDcCaptureConfig.protocols.length === 0}
                    onClick={() => onApprove(selectedDcCaptureConfig)}>
                    Send
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default StartCaptureModal;
